import { render, staticRenderFns } from "./TestpaperEdit.vue?vue&type=template&id=27a35f82&"
import script from "./TestpaperEdit.vue?vue&type=script&lang=js&"
export * from "./TestpaperEdit.vue?vue&type=script&lang=js&"
import style0 from "./TestpaperEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports